import type { PropsWithChildren, ReactNode } from "react";
import { Button, Dialog, DialogTrigger, Popover } from "react-aria-components";

type DropdownTypes = {
  text: ReactNode;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  label?: string;
};

export function NavDropdown(props: PropsWithChildren<DropdownTypes>) {
  return (
    <DialogTrigger>
      <Button
        className="flex cursor-pointer items-center p-0"
        aria-label={props.label}
        onPress={() => props.setIsOpen(!props.isOpen)}
      >
        {props.text}
      </Button>
      <Popover
        isOpen={props.isOpen}
        onOpenChange={props.setIsOpen}
        placement="bottom"
        className="overflow-y-auto rounded-lg border-1 border-border-active bg-fill-solid shadow-md"
      >
        <Dialog>{props.children}</Dialog>
      </Popover>
    </DialogTrigger>
  );
}
